import { DashboardNotifications } from '@dev/ee-api/ee-api-models';

export const getPersonaSurveyUrl = (notification: DashboardNotifications): string => {
    switch (notification) {
        case DashboardNotifications.SophieMarketingNotification:
            return 'https://tally.so/r/mRgRZ9';
        case DashboardNotifications.AlexMarketingNotification:
            return 'https://tally.so/r/mBgZ0N';
        case DashboardNotifications.JakeMarketingNotification:
            return 'https://tally.so/r/3jpLER';
        case DashboardNotifications.LindaMarketingNotification:
            return 'https://tally.so/r/nWgPdP';
        default:
            return '';
    }
};
